import ServiceBase from './serviceBase';
import { PowerBIReportDto } from './types/PowerBI';

class PowerBIService extends ServiceBase {
  getReport = async (): Promise<PowerBIReportDto> =>
    this.get<PowerBIReportDto>('powerbi/report_ES_Insight');

  getReport2 = async (): Promise<PowerBIReportDto> =>
    this.get<PowerBIReportDto>('powerbi/report_GrievanceProtocol');
}

const powerBIService = new PowerBIService();
export default powerBIService;
